interface ImagePreviewProps {
  src: string;
}

export function ImagePreview({ src }: ImagePreviewProps) {
  return (
    <div
      className="flex flex-1 items-center justify-center overflow-auto bg-muted/20 p-4"
      data-testid="project-files-image-preview"
    >
      <img src={src} alt="" className="max-h-full max-w-full rounded object-contain shadow-sm" />
    </div>
  );
}
